export enum Section {
  Eco = 'ECO PACKAGING',
  Diwali = 'DIWALI MENU',
  Holi = 'HOLI MENU',
  Thanksgiving = 'THANKSGIVING MENU',
  Hanukkah = 'HANUKKAH MENU',
  Christmas = 'CHRISTMAS MENU',
  Kwanzaa = 'KWANZAA MENU',
  LunarNewYear = 'LUNAR NEW YEAR MENU',
  Easter = 'EASTER MENU',
  NewYear = 'NEW YEAR MENU',
  Valentines = "VALENTINE'S DAY MENU",
  Nowruz = 'NOWRUZ MENU',
  Ramadan = 'RAMADAN MENU',
  EidAlFitr = 'EID AL-FITR MENU',
  Vesak = 'VESAK MENU',
  Main = 'Main',
  Side = 'Side',
  Kids = 'KIDS ITEMS',
  Drop = 'Drop', // items we wont display
}

export const sectionOrder = [
  Section.Eco,
  Section.Diwali,
  Section.Holi,
  Section.Thanksgiving,
  Section.Hanukkah,
  Section.Christmas,
  Section.Kwanzaa,
  Section.LunarNewYear,
  Section.Main,
  Section.Side,
  Section.Kids,
];
